import React, {Component} from 'react';
import FontAwesome from 'react-fontawesome';
import firebase from 'firebase';
import 'firebase/functions';
import {EditorDialog} from '../editor-components';
import Spinner from '../spinner/spinner';

/** @class EmailBoothReviewDialog
  * A component for managing the emailing of a booth review link
  * and the associated process of creating an exhibitor user to
  * acccess that booth preview.
  */
export default class EmailBoothReviewDialog extends Component {
  /** @constructor
    * Constructs a new instance of the BoothReivewDialog component.
    */
  constructor(props){
    super(props);
    this.state = {
      showDialog: false,
      sendingEmails: false,
      emails: props.exhibitor.email || ''
    }
    this.handleChange = this.handleChange.bind(this);
    this.sendEmails = this.sendEmails.bind(this);
  }
  /** @method handleChange
    * Event handler for updating the component state based on input events
    * @param event - the event causing the state change
    */
  handleChange(event) {
    this.setState({
      [event.target.name]: event.target.value
    });
  }
  /** @method sendEmails
    * Sends the email(s) containg the booth review link
    */
  sendEmails() {
    const sendLink = firebase.functions().httpsCallable('sendBoothReviewLink');
    const emails = this.state.emails.split(/\s*[,;]\s*/);
    this.setState({sendingEmails: true});
    emails.forEach(email => {
      sendLink({
          url: `${window.location.protocol}//${window.location.host}#${this.props.reviewURL}`,
          expo: this.props.expoID,
          show: this.props.showID,
          name: this.props.exhibitor.brand,
          exhibitor: this.props.exhibitor.id,
          email: email
      }).then(()=>{
        alert(`Emails were sent to ${emails}`);
        this.setState({showDialog: false});
      }).catch(err => {
        alert(`There was an error sending emails: ${err}`);
        console.error(err);
      }).finally(()=>{
        this.setState({sendingEmails: false});
      });
    });
  }
  /** @method render
    * Renders the component
    */
  render() {
    const style={maxWidth: "80vw"}
    const dialogContent = (this.state.sendingEmails) ? (
      <Spinner />
    ) : (
      <div>
        Enter emails to send the <b>{this.props.name}</b> booth review link to:
        <p className="hint">
          Multiple emails can be separated with commas or semicolons.
        </p>
        <textarea name="emails" onChange={this.handleChange} value={this.state.emails} style={{height: "50px", width: "100%"}}/>
        <div>
          <button className="btn btn-success" onClick={this.sendEmails}>
            <FontAwesome name="send"/>
            Send Emails
          </button>
        </div>
      </div>
    );
    var dialog = (this.state.showDialog) ? (
      <EditorDialog show={this.state.showDialog} onExit={() => this.setState({showDialog: false})}>
        <h2>Email Booth Review Link</h2>
        <div style={style}>
          {dialogContent}
        </div>
      </EditorDialog>
    ):'';
    return (
      <span>
        <a href="#" onClick={() => this.setState({showDialog: true})}>
          <FontAwesome name="envelope" style={{color: "blue", border: "none"}}/>
        </a>
        {dialog}
      </span>
    );
  }
}



// WEBPACK FOOTER //
// ./src/exhibitor-list/email-booth-review-button.js